module.exports = __webpack_public_path__ + "static/img/6.6cb55be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/6.png
// module id = QpzX
// module chunks = 0